var e = e || {},
    solustab = solustab || {};
( function () {
    'use strict';
    solustab.constant = {
        jHtml: jQuery( '.js-form-calculator' )
    };
    if ( solustab.constant.jHtml.length > 0 ) {
        solustab.config = {
            pageLanguage: solustab.constant.jHtml.attr( 'lang' ),
            IntergerSeparator: solustab.constant.jHtml.data( 'integer-separator' ),
            DecimalSeparator: solustab.constant.jHtml.data( 'decimal-separator' )
        };
        if ( solustab.config.IntergerSeparator === ' ' || solustab.config.IntergerSeparator.charCodeAt( 0 ) === 160 ) {
            solustab.config.regExpIntergerSeparator = new RegExp( '(\\s|&nbsp;|\\u00A0)', 'g' );
        }
        else {
            solustab.config.regExpIntergerSeparator = new RegExp( '\\' + solustab.config.IntergerSeparator, 'g' );
        }
        if ( solustab.config.DecimalSeparator === ' ' || solustab.config.DecimalSeparator.charCodeAt( 0 ) === 160 ) {
            solustab.config.regExpDecimalSeparator = new RegExp( '(\\s|&nbsp;|\\u00A0)', 'g' );
        }
        else {
            solustab.config.regExpDecimalSeparator = new RegExp( '\\' + solustab.config.DecimalSeparator, 'g' );
        }
    }
    solustab.countDecimals = function(value) {
        if (value.toString().split('.')[1] !== undefined){
            return value.toString().split('.')[1].length || 0;
        }
        return 0;
    };
    solustab.formatNumber = function formatNumber( number, numberToCount ) {
        var decimalCount = solustab.countDecimals(solustab.formatNumberToJavascript(numberToCount));

        number = number.toFixed(decimalCount > 1 ? decimalCount : 2);
        number = number.replace( /\./g, '{decimal}' );
        number = number.replace( new RegExp( '{decimal}', 'g' ), solustab.config.DecimalSeparator );

        return number;
    };
    solustab.formatNumberToJavascript = function ( number ) {
        return parseFloat( String( number ).replace( solustab.config.regExpIntergerSeparator, '' ).replace( solustab.config.regExpDecimalSeparator, '.' ) );
    };
    jQuery( function () {
        solustab.calculator.onLoad();
        solustab.showHeaderButtons();
        solustab.preferences.resetOnClick();
        solustab.preferences.changeCountry();
        solustab.goBack.previousLevel();
        solustab.disclaimer.accepted();
        solustab.animalsAndProducts.onClick();
        solustab.calculator.changeWeight();
        solustab.spinners();
        solustab.shareCalculation();
    } );
    solustab.calculator = {};
    solustab.calculator.changeWeight = function () {
        jQuery( 'select#age' ).on( 'change', function () {
            jQuery( 'input#weight' ).val( jQuery( this ).find( ':selected' ).data( 'weight' ) );
            jQuery( 'input#waterintake' ).val( jQuery( this ).find( ':selected' ).data( 'waterintake' ) );
            jQuery( '.recommended-intake' ).text( jQuery( this ).find( ':selected' ).data( 'waterintake' ) );
        } );
    };
    solustab.calculator.onLoad = function () {
        if ( jQuery( '.js-has-been-calculated' ).length > 0 ) {
            setTimeout( function () {
                e.util.scroll.toElement( jQuery( '#calculated' ), 1, false, true );
            }, 50 );
        }
        jQuery( '.recommended-intake' ).text( jQuery( 'select#age' ).find( ':selected' ).data( 'waterintake' ) );
    };
    solustab.showHeaderButtons = function () {
        if ( jQuery( '.js-single-site' ).length < 1 ) {
            jQuery( '.js-reset-country' ).show();
        }
        if ( jQuery.cookie( 'Language' ) ) {
            jQuery( '.js-go-back' ).show();
        }
        if ( jQuery.cookie( 'Language' ) ) {
            jQuery( '.js-reset-language' ).show();
        }
        if ( jQuery( '.js-single-site' ).length > 0 ) {
            var downloadFile = jQuery( '.js-single-site' ).data( 'download-file' );
            if ( downloadFile !== '' ) {
                jQuery( '.js-download-file' ).attr( 'href', downloadFile ).attr( 'title', jQuery( '.js-single-site' ).data( 'download-title' ) ).show();
            }
        }
    };
    solustab.preferences = {};
    solustab.preferences.resetOnClick = function () {
        jQuery( '.js-reset-country' ).on( 'click', function () {
            jQuery.removeCookie( 'Country', {
                path: location.pathname
            } );
            solustab.topPageRedirect();
        } );
        jQuery( '.js-reset-language' ).on( 'click', function () {
            jQuery.removeCookie( 'Language', {
                path: location.pathname
            } );
            solustab.topPageRedirect();
        } );
    };
    solustab.preferences.changeCountry = function () {
        if ( jQuery( '.solustab-frontpage' ).length > 0 ) {
            jQuery( '.js-solustab-frontpage-country' ).attr( 'action', '/' + jQuery( 'select#country' ).find( ':selected' ).data( 'country-code' ) );
            jQuery( 'select#country' ).on( 'change', function () {
                jQuery( '.js-solustab-frontpage-country' ).attr( 'action', '/' + jQuery( this ).find( ':selected' ).data( 'country-code' ) );
            } );
        }
    };
    solustab.goBack = {};
    solustab.goBack.previousLevel = function () {
        jQuery( '.js-go-back' ).on( 'click', function () {
            if ( jQuery( '.js-history-back' ).length > 0 ) {
                if ( jQuery( '.js-single-site' ).length > 0 ) {
                    window.location.href = location.protocol + '//' + location.host + location.pathname;
                }
                else {
                    jQuery( '.js-go-back' ).parent().submit();
                }
            }
            else {
                var level = jQuery( '.js-level' ).data( 'level' );
                jQuery.removeCookie( level, {
                    path: location.pathname
                } );
                solustab.topPageRedirect();
            }
        } );
    };
    solustab.disclaimer = {};
    solustab.disclaimer.accepted = function () {
        jQuery( '.js-accept-disclaimer' ).on( 'change', function () {
            jQuery( '.js-accept-disclaimer-button' ).prop( 'disabled', function ( i, v ) {
                return !v;
            } );
        } );
        jQuery( '.js-accept-disclaimer-button' ).on( 'click', function () {
            jQuery.cookie( 'Disclaimer', 'Accepted', {
                path: location.pathname,
                expires: 14
            } );
            solustab.topPageRedirect();
        } );
    };
    solustab.animalsAndProducts = {};
    solustab.animalsAndProducts.onClick = function () {
        jQuery( '.js-animal-list label, .js-product-list label' ).on( 'click', function () {
            jQuery( this ).next().prop( 'checked', true );
            setTimeout( function () {
                jQuery( '.js-form-submit' ).submit();
            }, 50 );
        } );
    };
    solustab.topPageRedirect = function () {
        window.location.href = location.protocol + '//' + location.host + location.pathname;
    };
    solustab.spinners = function () {
        var parentValue, calculatedValue;
        jQuery( '.input-group-btn-vertical' ).on( 'click', '.btn:first-of-type', function () {
            parentValue = jQuery( this ).parent().siblings( 'input' ).val();
            calculatedValue = solustab.formatNumberToJavascript( parentValue ) + solustab.formatNumberToJavascript( jQuery( this ).parent().siblings( 'input' ).data( 'step' ) );
            jQuery( this ).parent().siblings( 'input' ).val( solustab.formatNumber( calculatedValue, parentValue ) );
        } );
        jQuery( '.input-group-btn-vertical' ).on( 'click', '.btn:last-of-type', function () {
            parentValue = jQuery( this ).parent().siblings( 'input' ).val();
            calculatedValue = solustab.formatNumberToJavascript( parentValue ) - solustab.formatNumberToJavascript( jQuery( this ).parent().siblings( 'input' ).data( 'step' ) );
            jQuery( this ).parent().siblings( 'input' ).val( solustab.formatNumber( calculatedValue, parentValue ) );
        } );
    };
    solustab.shareCalculation = function () {
        if ( jQuery( '.js-share-calculation-modal-trigger' ).length > 0 ) {
            jQuery( '.js-share-calculation-modal-trigger' ).on( 'click', function ( e ) {
                e.preventDefault();
                jQuery( '.share-calculation-modal' ).modal( 'show' );
            } );
            jQuery( '.js-copy-to-clipboard' ).on( 'click', function (e) {
                e.preventDefault();
                var temp = jQuery( '<input>' );
                jQuery( 'body' ).append( temp );
                temp.val( jQuery( this ).attr( 'href' ) ).select();
                document.execCommand( 'copy' );
                temp.remove();
                jQuery( '.share-calculation-modal' ).modal( 'hide' );
            } );
        }
    };
}() );